var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.333496H2C0.893333 0.333496 0 1.22016 0 2.3135V9.58683C0 10.6802 0.893333 11.5668 2 11.5668H2.50667C3.04 11.5668 3.54667 11.7735 3.92 12.1468L5.06 13.2735C5.58 13.7868 6.42667 13.7868 6.94667 13.2735L8.08667 12.1468C8.46 11.7735 8.97333 11.5668 9.5 11.5668H10C11.1067 11.5668 12 10.6802 12 9.58683V2.3135C12 1.22016 11.1067 0.333496 10 0.333496ZM6 2.8335C6.86 2.8335 7.55333 3.52683 7.55333 4.38683C7.55333 5.24683 6.86 5.94016 6 5.94016C5.14 5.94016 4.44667 5.24016 4.44667 4.38683C4.44667 3.52683 5.14 2.8335 6 2.8335ZM7.78667 9.04016H4.21333C3.67333 9.04016 3.36 8.44016 3.66 7.9935C4.11333 7.32016 4.99333 6.86683 6 6.86683C7.00667 6.86683 7.88667 7.32016 8.34 7.9935C8.64 8.44016 8.32 9.04016 7.78667 9.04016Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.3424ceb4cef8212f4ef92bd3ed298701.svg";
export { ForwardRef as ReactComponent };